<template>
  <div>
    <div class="top">
      <div class="tax">
        <img src="~assets/images/common/tax.png"/>
        <span>{{ taxName }}</span>
      </div>
      <div class="searchBox">
        <Select
            class="searchSelect"
            style="width: 280px"
            v-model="searchAcc"
            multiple
            filterable
            clearable
            :default-label="[]"
            :remote-method="(file) =>remoteMethod(file,'accOptions','gcdUser','queryUserListWithoutPermission')"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) =>setDefaultOptions(file,'accOptions')"
        >
          <Option v-for="option in accOptions" :value="option.id"
                  :key="option.id">{{ option.userName }}
          </Option>
        </Select>
        <Button type="primary" style="margin-left: 10px;border-radius: 5px;" @click="addTaxClient">添加</Button>
      </div>
    </div>
    <div class="tree">
      <div v-for="(item,index) in treeData" :key="index">
        <div class="leaf">
          <div class="link-line"></div>
          <div class="content">
            <span>{{ item.userName }}</span>
            <img src="~assets/images/common/delete.png" style="cursor: pointer" @click="commitDel(item.userSignId)">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer add-btn-box">
      <Button type="primary" style="width: 100px;border-radius: 5px" @click="close">确 定</Button>
    </div>
  </div>
</template>
<script>

import {hideLoading, isEmpty, showLoading} from "@/utils/util";
import $api from "@/apiProvider";

export default {
  data() {
    return {
      searchLoading: false,
      searchAcc: [],
      accOptions: [],
      taxName: '',
      taxId: null,
      treeData: []
    }
  },
  methods: {
    init(row) {
      this.taxName = row.taxComp;
      this.taxId = row.id;
      this.searchAcc = [];
      this.getTaxClient(row.id);
    },
    async getTaxClient(id) {
      let res = await $api.tax.post('getTaxClient', {
        id: id
      });
      if (res.status === 1) {
        this.treeData = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async addTaxClient() {
      if (this.searchAcc.length === 0) {
        this.$XModal.alert({
          message: "请选择客户",
          status: "error",
        });
        return;
      }
      showLoading();
      let res = await $api.tax.post('addTaxClient', {
        taxId: this.taxId,
        userIds: this.searchAcc
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("添加成功");
        this.getTaxClient(this.taxId);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async commitDel(id) {
      let res = await $api.tax.post('delTaxClient', {
        id: id
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.getTaxClient(this.taxId);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    async getList(query, options, url, path) {
      let params = {
        userType: 2,
        orderBy: 2,
        page: 1,
        rows: 10,
      };

      if (!isEmpty(query)) {
        params.username = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data.rows;
        this[options] = [];
        data.map((i, index) => {
          this[options].push(i)
        })
      }
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>
<style scoped>
.top {
  display: flex;
  align-items: center;
}

.tax {
  display: flex;
  align-items: center;
}

.tax span {
  font-size: 18px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: bold;
  color: #333333;
  margin-left: 10px;
}

.tax img {
  width: 24px;
  height: 24px;
}

.searchBox {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.tree {
  margin-left: 37px;
  height: 360px;
  overflow-y: auto;
}

.leaf {
  display: flex;
  align-items: center;
  position: relative;
}

.leaf span {
  font-size: 14px;
  font-family: MicrosoftYaHei, sans-serif;
  line-height: 40px;
  color: #333333;
}

.leaf img {
  width: 16px;
  height: 16px;
  margin-left: 10px;
}

.link-line {
  width: 20px;
  height: 40px;
  border-left: 1px solid #DCDFE6;
  border-bottom: 1px solid #DCDFE6;
}

.content {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: -20px;
  left: 30px;
}

.modal-footer {
  padding: 10px 0;
  display: flex;
  justify-content: flex-end;
  width: 96%;
  position: absolute;
  bottom: 0;
}

.searchSelect >>> .ivu-tag-text {
  width: 80px;
}
</style>

